var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from "styled-components";
import tinycolor from "tinycolor2";
export var inputStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  width: 100%;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  padding: 12px 12px;\n  line-height: 1em;\n  font-size: 1.4rem;\n  height: 40px;\n  outline: none;\n  color: ", ";\n\n  &:disabled {\n    background-color: ", ";\n  }\n\n  &:focus {\n    background-color: ", ";\n    border: 1px solid\n      ", ";\n  }\n\n  &.small {\n    height: unset;\n    font-size: 1.2rem;\n    padding: 8px 8px;\n  }\n"], ["\n  display: inline-block;\n  width: 100%;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  padding: 12px 12px;\n  line-height: 1em;\n  font-size: 1.4rem;\n  height: 40px;\n  outline: none;\n  color: ", ";\n\n  &:disabled {\n    background-color: ",
    ";\n  }\n\n  &:focus {\n    background-color: ",
    ";\n    border: 1px solid\n      ",
    ";\n  }\n\n  &.small {\n    height: unset;\n    font-size: 1.2rem;\n    padding: 8px 8px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.inputs.main.borderColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.inputs.main.color;
}, function (_a) {
    var theme = _a.theme;
    return tinycolor(theme.colors.white).darken(10).toString();
}, function (_a) {
    var theme = _a.theme;
    return theme.name === "default"
        ? tinycolor(theme.gwThemed.inputs.main.color).lighten(45).toString()
        : theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.name === "default"
        ? theme.gwThemed.inputs.main.borderColor
        : theme.gwThemed.inputs.main.color;
});
var templateObject_1;
//# sourceMappingURL=InputTextStyle.js.map